import { styled } from "@mui/material";
import { hintCheck } from "../../UserHome/Base/SVG";
import { benefits } from "./BizdevInternshipData";

const BizdevInternshipBenefits = () => {
  return (
    <Root>
      <Header>What You'll Walk Away With</Header>
      <Content>
        {benefits.map((i, _) => (
          <BenefitBox key={i.header}>
            <div>
              {hintCheck} <h4>{i.header}</h4>
            </div>
            <p>{i.body}</p>
          </BenefitBox>
        ))}
      </Content>
    </Root>
  );
};

export default BizdevInternshipBenefits;

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "80px",
  [theme.breakpoints.down(500)]: {
    gap: "31px",
  },
}));

const Header = styled("h2")(({ theme }) => ({
  textAlign: "center",
  width: "831px",
  margin: "auto",
  fontSize: "48px",
  lineHeight: 1.33,
  fontWeight: 700,
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
    fontSize: "35px",
    lineHeight: 1.3,
  },
  [theme.breakpoints.down(500)]: {
    fontSize: "24px",
    lineHeight: "35px",
  },
}));

const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  // gap: "20px",
  width: "100%",
  flexWrap: "wrap",
  [theme.breakpoints.down(900)]: {
    flexDirection: "column",
    gap: "21px",
  },
}));

const BenefitBox = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  width: "30%",
  minWidth: "280px",
  paddingBottom: "20px",
  paddingRight: "20px",
  "&>div": {
    display: "flex",
    gap: 20,
    alignItems: "center",
    "&>h4": {
      fontSize: "18px",
      lineHeight: "30px",
      fontWeight: 700,
    },
  },
  "&>p": {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#B7B7B7",
  },
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingBottom: "0px",
    paddingRight: "0px",
  },
}));
